import { render, staticRenderFns } from "./RightDadosCadastrais.vue?vue&type=template&id=b043b8f4"
import script from "./RightDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./RightDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports